module.exports = __webpack_public_path__ + "img/10800.c808fd9e.jpg";